var map = {
	"./CMMI-Level-5-Software-Certificate.jpg": 96894,
	"./DIPP-Strat-up.jpg": 94451,
	"./Factory-License-RePrint-Certificate-FIRSTFLOOR.jpg": 82803,
	"./Factory-License-RePrint-Certificate-MANUFACTURING.jpg": 5581,
	"./GST.jpg": 92543,
	"./ISO-14001.jpg": 76441,
	"./ISO-20000-1.jpg": 82497,
	"./ISO-27001.jpg": 76635,
	"./ISO-45001.jpg": 49355,
	"./ISO-9001.jpg": 94807,
	"./Installation-License.jpg": 53291,
	"./MSME-ZED.jpg": 71021,
	"./MSME.jpg": 4111
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 79229;